import RetailerApi from "@/services/api/retailerApi";
import MiscApi from "@/services/api/misc";
import { mapGetters } from "vuex";

const RetailerApiService = new RetailerApi();
const MiscApiService = new MiscApi();

export default {
  data() {
    return {
      retailer_id: this.$route.params.id,
      requested: false,
      statuses: null,
      balanceLevels: null,
      model: {
        first_name: "",
        last_name: "",
        email: "",
        store_name: "",
        location: "",
        instagram: "",
        year_founded: "",
        bio: null,
        thumbnail_image_url: null,
        store_location_id: null,
        balance_level: null,
        balance: "",
      },
      uploadInProgressThumb: false,
      countries: null,
    };
  },

  beforeMount() {
    this.getInfo();
    this.getRetailerStatuses();
    this.getCountries();
  },

  methods: {
    getRetailerStatuses,
    onThumbImageInputChange,
    removeThumbImage,
    triggerThumbImageUpload,
    getInfo,
    validate,
    save,
    handleRadioClick,
    getCountries,
    onStoreLocationSelected,
    fetchRetailerBalanceLevels,
  },

  computed: {
    selectedCountry() {
      if (!this.countries) return;

      return this.countries.find((country) => country.name === this.model.location).name;
    },
    ...mapGetters({
      user: "userState",
    }),
    statusesDropdownItems() {
      return (
        this.statuses &&
        this.statuses.map((status) => ({
          name: status.value,
        }))
      );
    },
  },
};

function getInfo() {
  RetailerApiService.getRetailerById(this.retailer_id)
    .then((response) => {
      this.model = response.data;
      this.$validator.reset();
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$bugsnagClient.notify(new Error(error));
      }
    });

  this.fetchRetailerBalanceLevels();
}

function getRetailerStatuses() {
  RetailerApiService.getRetailerStatuses()
    .then(({ data }) => {
      this.statuses = data.options;
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$bugsnagClient.notify(new Error(error));
      }
    });
}

async function onThumbImageInputChange(e) {
  if (!e.target.files.length) {
    return;
  }
  const previousThumb = this.model.thumbnail_image_url; // use this if upload fails
  this.removeThumbImage();
  const file = e.target.files[0];
  //size check
  if (file.size > this.$utils.getByteSizeFromMegabyteSize(this.$utils.constants.IMAGE_UPLOAD_SIZE_LIMIT_MB)) {
    return this.$swal({ title: this.$utils.constants.IMAGE_UPLOAD_SIZE_LIMIT_ERROR_MESSAGE });
  }
  //begin upload process
  this.uploadInProgressThumb = true;
  let formData = new FormData();
  formData.append("file", file);
  try {
    const { data } = await RetailerApiService.uploadRetailerThumb(formData);
    this.model.thumbnail_image_url = data.url;
    this.uploadInProgressThumb = false;
  } catch (e) {
    this.model.thumbnail_image_url = previousThumb;
    this.uploadInProgressThumb = false;
    return this.$swal("Alert", "Something went wrong. Please try again .");
  }
}
function removeThumbImage() {
  this.model.thumbnail_image_url = null;
}
function triggerThumbImageUpload() {
  this.$refs.imageInput.click();
}

function validate() {
  this.$validator.validate().then((valid) => {
    if (!valid) {
      return this.$swal(
        "Attention",
        this.errors.items
          .map((error) => error.msg)
          .toString()
          .replace(",", " ")
      );
    }
    this.save();
  });
}

function save() {
  this.requested = true;

  let request = { ...this.model };
  delete request.location;

  RetailerApiService.updateRetailerAccountById(this.retailer_id, request)
    .then(() => {
      this.$swal("Success", "Profile updated successfully.");
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$bugsnagClient.notify(new Error(error));
      }
    })
    .finally(() => {
      this.requested = false;
    });
}
async function handleRadioClick(previousStatus, nextStatus) {
  if (previousStatus === nextStatus) {
    // disable click if already selected
    return;
  }
  const modal = await this.$swal({
    text: `Are you sure you want to change ${this.model.store_name}'s status from: ${previousStatus} to ${nextStatus}?`,
    title: "Warning",
    showCancelButton: true,
    cancelButtonText: "No",
    confirmButtonText: "Yes",
  });
  const isConfirmed = modal.value;
  this.model.status = isConfirmed ? nextStatus : previousStatus;
  if (isConfirmed) {
    try {
      await RetailerApiService.updateRetailerStatus(this.retailer_id, { status: nextStatus });
    } catch (error) {
      this.$swal("Attention", error.response.data.error_message, "error");
    }
  }
}

function getCountries() {
  MiscApiService.getAllCountries().then(({ data }) => {
    this.countries = data;
  });
}

function onStoreLocationSelected(country) {
  this.model.store_location_id = country.id;
}
function fetchRetailerBalanceLevels() {
  RetailerApiService.fetchRetailerBalanceLevels().then(({ data }) => {
    this.balanceLevels = data.options;
  });
}
